import React from "react";
import Grid from '@material-ui/core/Grid';
import { ErrorMessage, Form, Formik } from "formik";
import { connect } from "react-redux";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import { Link } from "react-router-dom";
import { LoginSchema } from "../../helpers/schemas";
import { FormattedMessage } from "react-intl";
import CustomTextField from '../general/CustomTextField';
import CustomPasswordField from '../general/CustomPasswordField';
import { ROUTE_FORGOT_PASSWORD } from '../../config/routes';
import { requestLogin } from '../../store/actions/user';

class LoginComponent extends React.Component {

    submit = (data) => {
        const { email, password } = data;
        this.props.requestLogin(email, password, this.props.lang);
    };

    renderForm = (props) => {
        const { touched, errors, isValid } = props;

        return (
            <Form className="login-form" autoComplete="off">
                <Grid container direction="column" spacing={3}>
                    <Grid item className="custom-field">
                        <FormattedMessage id="globals.email_address">
                            {email_address =>
                                <CustomTextField
                                    type="email"
                                    name="email"
                                    label={email_address}
                                    error={errors.email && touched.email}
                                    onChange={e => props.setFieldValue( 'email', e.target.value )}
                                    handleBlur={props.handleBlur}
                                />
                            }
                        </FormattedMessage>
                        <ErrorMessage data-testid="errors-email" name="email" component="div" className="field-error"/>
                    </Grid>

                    <Grid item className="custom-field">
                        <FormattedMessage id="globals.password">
                            {password =>
                                <CustomPasswordField
                                    name="password"
                                    label={password}
                                    error={errors.password && touched.password}
                                    onChange={e => props.setFieldValue( 'password', e.target.value )}
                                    handleBlur={props.handleBlur}
                                />
                            }
                        </FormattedMessage>
                        <ErrorMessage name="password" component="div" className="field-error"/>
                    </Grid>

                    <Grid item className="custom-field">
                        <Link className="login-link" to={ROUTE_FORGOT_PASSWORD}>
                            <FormattedMessage id="login.forgot"/>
                        </Link>
                    </Grid>

                    <Grid container>
                        <button
                            name="login"
                            type="submit"
                            disabled={! isValid}>
                            <FormattedMessage id="globals.submit"/>
                            <span><ChevronRightIcon fontSize="small"/></span>
                        </button>
                    </Grid>
                </Grid>
            </Form>
        );
    };

    render() {
        return (
            <div className='login-container'>
                <Formik
                    initialValues={{ email: '', password: '' }}
                    validationSchema={LoginSchema}
                    onSubmit={this.submit}
                    enableReinitialize={true}
                    validateOnBlur={true}
                    validateOnMount={true}
                >
                    {this.renderForm}
                </Formik>
            </div>
        )
    }
};

const mapStateToProps = state => ({
    lang: state.locale.lang
});

const Login = connect(mapStateToProps, { requestLogin })(LoginComponent);

export { Login, LoginComponent };
